import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

export interface DocumentRelation {
  type: string;
  id: number;
  id_by_company: number | string;
}

interface RelationTypeMeta {
  label: string;
  short: string;
  color: string;
  bg: string;
  dot: string;
}

const RELATION_TYPE_META: Record<string, RelationTypeMeta> = {
  presupuesto: { label: 'Presupuesto', short: 'P', color: '#9C6B12', bg: '#FBEFDB', dot: '#C08A2E' },
  albaran: { label: 'Albarán', short: 'A', color: '#2F4EA6', bg: '#E7ECFB', dot: '#3457D5' },
  factura: { label: 'Factura', short: 'F', color: '#1C7A47', bg: '#E1F5E9', dot: '#1E9E5A' },
  devolucion: { label: 'Devolución', short: 'D', color: '#B8291F', bg: '#FBE4E2', dot: '#D23B3B' },
  proforma: { label: 'Proforma', short: 'PF', color: '#4B5563', bg: '#F1F2F4', dot: '#6B7280' },
};

const FALLBACK_META: RelationTypeMeta = { label: 'Documento', short: '?', color: '#374151', bg: '#F1F2F4', dot: '#9CA3AF' };

/** Design option "1b" — chips por tipo de documento, con desplegable al hacer clic. */
@Component({
  selector: 'document-relation-chips',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './document-relation-chips.component.html',
})
export class DocumentRelationChipsComponent {
  @Input() relations: DocumentRelation[] = [];
  @Input() linkFor: (rel: DocumentRelation) => string = () => '#';
  @Input() openInNewTab = true;

  isOpen = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  meta(type: string): RelationTypeMeta {
    return RELATION_TYPE_META[type] ?? FALLBACK_META;
  }

  toggle(event: Event): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }
}
